"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledReportFilters = void 0;
var styled_components_1 = __importStar(require("styled-components"));
exports.StyledReportFilters = styled_components_1.default.div(function (_a) {
    var _b = _a.theme, Colors = _b.Colors, Spacing = _b.Spacing, Typography = _b.Typography;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n\n    .module-filter {\n      display: flex;\n      align-items: center;\n      margin-right: ", ";\n\n      > label {\n        font-size: ", ";\n        margin: ", ";\n        color: ", ";\n      }\n    }\n\n    .assessment-filter {\n      margin: ", ";\n    }\n\n    > button {\n      letter-spacing: 2px;\n      text-transform: uppercase;\n      width: 192px;\n      margin: ", ";\n\n      &.disabled,\n      &:disabled {\n        background-color: ", ";\n        border: none;\n        color: ", ";\n        pointer-events: none;\n      }\n    }\n  "], ["\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n\n    .module-filter {\n      display: flex;\n      align-items: center;\n      margin-right: ", ";\n\n      > label {\n        font-size: ", ";\n        margin: ", ";\n        color: ", ";\n      }\n    }\n\n    .assessment-filter {\n      margin: ", ";\n    }\n\n    > button {\n      letter-spacing: 2px;\n      text-transform: uppercase;\n      width: 192px;\n      margin: ", ";\n\n      &.disabled,\n      &:disabled {\n        background-color: ", ";\n        border: none;\n        color: ", ";\n        pointer-events: none;\n      }\n    }\n  "])), Spacing.x4, Typography.Sizes.smd, "0 ".concat(Spacing.x2, " 0 ").concat(Spacing.x4), Colors.Typography.secondary, "".concat(Spacing.x2, " ").concat(Spacing.x4, " ").concat(Spacing.x2, " 0"), "".concat(Spacing.x2, " 0 ").concat(Spacing.x2), Colors.Curriculum.ww.disabled, Colors.Typography.secondary);
});
var templateObject_1;
